// extracted by mini-css-extract-plugin
export default {"background":"site-stats_background__ugUyB"};